import React from 'react'

export const SubClo = () =>{

    return (
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 overflow-hidden">
            <div className="animate-marquee whitespace-nowrap">
                <span className="text-lg font-semibold mx-8">
                    🎉 GREAT NEWS! Deadline Extended to 12th January 2026! 🎉
                </span>
                <span className="text-lg font-semibold mx-8">
                    🎉 GREAT NEWS! Deadline Extended to 12th January 2026! 🎉
                </span>
                <span className="text-lg font-semibold mx-8">
                    🎉 GREAT NEWS! Deadline Extended to 12th January 2026! 🎉
                </span>
                <span className="text-lg font-semibold mx-8">
                    🎉 GREAT NEWS! Deadline Extended to 12th January 2026! 🎉
                </span>
            </div>
        </div>
    )
}